import { useState, useEffect } from 'react'
import { TooltipV2 } from 'builder/components/Tooltip'

import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { BookButton, Container, HorizontalLine } from './styles'

const TOOLTIP_TIMEOUT = 3800
const KEY = 'button_tooltip_seen'

type Props = {
  type: 'resume_writing' | 'career_coaching'
  text: string
  icon: React.ReactNode
  onClick: () => void
  tooltip: string
}

export const HeaderButton = ({ type, onClick, text, icon, tooltip }: Props) => {
  const { isPhone } = useMediaQueries()
  const LOCAL_STORAGE_KEY = `${type}_${KEY}`

  const isTooltipSeen = localStorage.getItem(LOCAL_STORAGE_KEY)
  const [isTooltipVisible, setIsTooltipVisible] = useState(!isTooltipSeen)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsTooltipVisible(false)
      localStorage.setItem(LOCAL_STORAGE_KEY, 'true')
    }, TOOLTIP_TIMEOUT)
    return () => clearTimeout(timeout)
  }, [LOCAL_STORAGE_KEY])

  return (
    <Container>
      <TooltipV2 multiline width={210} visible={isTooltipVisible} value={tooltip}>
        <div>
          <BookButton onClick={onClick}>
            {icon}
            {!isPhone && text}
          </BookButton>
        </div>
      </TooltipV2>
      <HorizontalLine />
    </Container>
  )
}
